import type {
  ExecutionCharter,
  MissionStageRequest,
  MissionStageResult,
} from "./contracts";

export interface MissionLedgerEntry {
  readonly sequence: number;
  readonly occurredAt: string;
  readonly type: string;
  readonly payload: unknown;
}

export interface MissionLedger {
  record(
    missionId: string,
    type: string,
    payload: unknown,
  ): Promise<void>;

  read(missionId: string): Promise<readonly MissionLedgerEntry[]>;
}

export class InMemoryMissionLedger implements MissionLedger {
  private readonly entries =
    new Map<string, MissionLedgerEntry[]>();

  async record(
    missionId: string,
    type: string,
    payload: unknown,
  ): Promise<void> {
    const current = this.entries.get(missionId) ?? [];

    current.push({
      sequence: current.length + 1,
      occurredAt: new Date().toISOString(),
      type,
      payload,
    });

    this.entries.set(missionId, current);
  }

  async read(
    missionId: string,
  ): Promise<readonly MissionLedgerEntry[]> {
    return [...(this.entries.get(missionId) ?? [])];
  }
}

export async function recordCharterAccepted(
  ledger: MissionLedger,
  charter: ExecutionCharter,
): Promise<void> {
  await ledger.record(
    charter.missionId,
    "EXECUTION_CHARTER_ACCEPTED",
    charter,
  );
}

export async function recordStageStarted(
  ledger: MissionLedger,
  request: MissionStageRequest,
): Promise<void> {
  await ledger.record(
    request.missionId,
    "MISSION_STAGE_STARTED",
    request,
  );
}

export async function recordStageFinished(
  ledger: MissionLedger,
  result: MissionStageResult,
): Promise<void> {
  await ledger.record(
    result.missionId,
    "MISSION_STAGE_FINISHED",
    result,
  );
}
